import {usePageLoading} from '@/Components/Common/Providers/PageLoadingProvider.jsx';
import PdfViewerHost from '@/Components/Common/PDF/PdfViewerHost.jsx';
import PatchNoteModal from '@/Components/AirWater/Modals/PatchNoteModal.jsx';
import Footer from '@/Components/Layouts/Footer.jsx';
import Header from '@/Components/Layouts/Header.jsx';
import AuthenticatedMenu from '@/Components/Menus/Main/AuthenticatedMenu.jsx';
import GuestMenu from '@/Components/Menus/Main/GuestMenu.jsx';
import {usePage, router} from '@inertiajs/react';
import {Backdrop, Box, CircularProgress} from '@mui/material';
import * as React from 'react';
import {memo} from 'react';

const MainLayout = ({children}) => {
    const {auth, layout, unseenChangelog} = usePage().props;
    const hideLayout = layout && layout === '0';
    const {page_loading} = usePageLoading();

    const [changelogModalOpen, setChangelogModalOpen] = React.useState(!!unseenChangelog);

    React.useEffect(() => {
        if (unseenChangelog) {
            setChangelogModalOpen(true);
        }
    }, [unseenChangelog?.id]);

    const handleCloseChangelogModal = () => {
        setChangelogModalOpen(false);
        router.patch(
            route('changelogs.seen'),
            {changelog_id: unseenChangelog.id},
            {preserveState: true, preserveScroll: true},
        );
    };

    return (
        <>
            <PatchNoteModal
                open={changelogModalOpen}
                changelog={unseenChangelog}
                onClose={handleCloseChangelogModal}
            />
            <Header>{auth?.user ? <AuthenticatedMenu /> : <GuestMenu />}</Header>
            <Box id="content" component="main">
                {children}
            </Box>
            {!hideLayout && <Footer />}
            <Backdrop sx={{color: 'white', zIndex: (theme) => theme.zIndex.drawer + 1}} open={page_loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <PdfViewerHost />
        </>
    );
};
export default memo(MainLayout);
